import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Snackbar,
  Alert,
} from "@mui/material";
import { CheckCircle, Cancel, Person } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import {
  headers,
  systemConfig,
  
  oauthUserMgmt,
} from "../../utils/utils";

const InvitationReview = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [ticketJsonData, setTicketJsonData] = useState({});
  const [successMessage, setSuccessMessage] = useState(false);
  const [board, setBoard] = useState("");
  const [user, setUser] = useState("");
  const [userObject, setUserObject] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);

  const queryParams = new URLSearchParams(location.search);
  const boardId = queryParams.get("bid");
  const boardUser = queryParams.get("uid");

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    console.log("Updated ticketJsonData:", ticketJsonData);
  }, [ticketJsonData]);
  const handleClose = () => {
    setSuccessMessage(false);
    setErrorMessage(null);
  };

  const fetchData = async () => {
    try {
      // Fetch ticket workflow data
      const response = await fetch(
        `${process.env.REACT_APP_TICKET_SERVER}/ticket/workFlow?board=${boardId}`,
        {
          method: "GET",
          headers: headers(),
        },
      );

      if (response.ok) {
        const result = await response.json();
        setTicketJsonData(result);
      } else {
        console.error("Failed to fetch ticket workflow data.");
      }

      // Fetch system config data
      const config = await systemConfig(boardId);
      if (config?.value) {
        setBoard(config.value);
      } else {
        console.error("Config value is not available.");
      }

      // Fetch user data
      await fetchUserName();
    } catch (error) {
      console.error("Error fetching data:", error);
      setErrorMessage("Failed to load data. Please try again later.");
    }
  };

  const fetchUserName = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_USER_MGMT}/admin/realms/eVyoog/users/${boardUser}`,
        {
          method: "GET",
          headers: oauthUserMgmt(),
        },
      );

      if (response.ok) {
        const userData = await response.json();
        const fullName = `${userData.firstName} ${userData.lastName}`;
        setUser(fullName);
        setUserObject(userData);
      } else {
        console.error("Failed to fetch user data.");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const handleAccept = async () => {
    console.log("Invitation accepted.", ticketJsonData);

    try {
      const updatedData = {
        ...ticketJsonData,
        members: [...ticketJsonData.members, boardUser],
      };

      const response = await fetch(
        `${process.env.REACT_APP_TICKET_SERVER}/ticket/workFlowUpdate?board=${boardId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...headers(),
          },
          body: JSON.stringify(updatedData),
        },
      );

      if (response.ok) {
        setSuccessMessage(true);
        await notifyToUser("A");
        setTimeout(() => {
          navigate("/ticket");
        }, 3000);
      } else {
        console.error("Failed to update ticket workflow.");
        setErrorMessage("Failed to accept the invitation. Please try again.");
      }
    } catch (error) {
      console.error("Error accepting invitation:", error);
      setErrorMessage("Failed to accept the invitation. Please try again.");
    }
  };

  const handleDecline = async () => {
    console.log("Invitation declined.");

    try {
      await notifyToUser("R");
      setTimeout(() => {
        navigate("/ticket");
      }, 3000);
    } catch (error) {
      console.error("Error declining invitation:", error);
      setErrorMessage("Failed to decline the invitation. Please try again.");
    }
  };

  const notifyToUser = async (status) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_NOTIFICATION}/notification/save?templatePath=/opt/eVyoog/systemconfig/mailTemplate/Ticket/InvitateResponse-${status}.html&mode=ST`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...headers(),
          },
          body: JSON.stringify({
            recipient: userObject.email,
            message: "",
            type: "EMAIL",
            subject: `Invitation to ${board} ${
              status === "A" ? "Accepted" : "Declined"
            }`,
            status: "PENDING",
          }),
        },
      );

      if (!response.ok) {
        console.error("Failed to send notification.");
      }
    } catch (error) {
      console.error("Error sending notification:", error);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f5f7fa",
        padding: 2,
      }}
    >
      <Card
        sx={{
          maxWidth: 700,
          boxShadow: 6,
          borderRadius: 4,
        }}
      >
        <Box
          sx={{
            height: 110,
            background:
              "url(https://source.unsplash.com/700x140/?team,collaboration)",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <CardContent>
          <Typography
            variant="h4"
            align="center"
            sx={{ fontWeight: "bold", mt: 2 }}
          >
            🎉 You're Invited!
          </Typography>
          <Box sx={{ textAlign: "center", mt: 3, mb: 3 }}>
            <Typography variant="body1">
              You’ve been invited to collaborate on the board
              <strong> “{board}”</strong>.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <strong>Requested By:</strong> {user}
            </Typography>
          </Box>
          <List>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <Person />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Board Name" secondary={board} />
            </ListItem>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <Person />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Requested By" secondary={user} />
            </ListItem>
          </List>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            {" "}
            {ticketJsonData && (
              <>
                <Grid item xs={6}>
                  <Button
                    variant="contained"
                    color="success"
                    fullWidth
                    startIcon={<CheckCircle />}
                    onClick={handleAccept}
                  >
                    Accept Invitation
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    variant="contained"
                    color="error"
                    fullWidth
                    startIcon={<Cancel />}
                    onClick={handleDecline}
                  >
                    Decline Invitation
                  </Button>
                </Grid>
              </>
            )}
          </Grid>
        </CardContent>
      </Card>
      <Snackbar
        open={Boolean(successMessage || errorMessage)} // Open only if there's a message
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {successMessage ? (
          <Alert onClose={handleClose} severity="success">
            Invitation accepted successfully!
          </Alert>
        ) : errorMessage ? (
          <Alert onClose={handleClose} severity="error">
            {errorMessage}
          </Alert>
        ) : null}
      </Snackbar>
    </Box>
  );
};

export default InvitationReview;
